import { useTranslation } from 'react-i18next';
import {
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  Button,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import Theme from '../../../Themes/main.theme';
import TableGridWithFilters from '../../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import LaunchIcon from '@mui/icons-material/Launch';
import { useState } from 'react';
import DialogAction from '../../../components/Dialog/DialogAction';

const SullogesAll = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  document.title = t('Συλλογές ΕΚΟΜΕ');

  const columns: GridColDef[] = [
    {
      field: 'collections:collectionsTitle',
      headerName: t('Τίτλος Συλλογής') || undefined,
      minWidth: 680,
      sortable: false,
      renderCell: ({ row }) => row['collections:collectionsTitle'][0]['@value'],
    },
    {
      field: 'collections:collectionsEnTitle',
      headerName: t('Τίτλος Συλλογής στα Αγγλικά') || undefined,
      minWidth: 680,
      sortable: false,
      renderCell: ({ row }) =>
        row['collections:collectionsEnTitle']?.[0]?.['@value'] || '-',
    },
    {
      field: 'info',
      headerName: t('Λεπτομέρειες') || undefined,
      minWidth: 150,
      sortable: false,
      renderCell: ({ row }) => (
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          title={t('Προβολή')}
        >
          <IconButton
            onClick={() => navigate(`/collections/details/${row['o:id']}`)}
          >
            <LaunchIcon color='primary' />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <Typography sx={{ my: 2 }} variant='h2'
        color={Theme?.labelColor?.main}>
        {t('Αναζήτηση Συλλογών Οπτικοακουστικών Φορέων')}
      </Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
      <Box mt={5} minWidth={350}>
        <Paper
          variant='outlined'
          sx={{
            height: 'fit-content',
            borderRadius: 2,
            boxShadow: 0,
            backgroundColor: 'transparent',
          }}
        >
          <Box display='flex' justifyContent='space-between'>
            <Typography m={2} variant='h3'>
              {t('Δείτε τις Συλλογές των Οπτικοακουστκών Φορέων')}
            </Typography>
            <Button sx={{ marginRight: 1, marginTop: 1 }}
              startIcon={<LaunchIcon />}
              variant='contained'
              onClick={() => setOpen(true)}
            >
              {t('Δείτε τις συλλογές του ΕΚΟΜΕ')}
            </Button>
          </Box>
          <Box m={1}>
            <TableGridWithFilters
              pageSize={15}
              paginationMode='server'
              rowsPerPageOptions={[15, 30, 45]}
              responseDataFieldName='data'
              responseTotalCountFieldName='totalResults'
              hideFilters
              sortingMode='server'
              columns={columns}
              fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/collections?is_public=1`}
            />
          </Box>
        </Paper>
      </Box>
      <DialogAction
        title={t('Συλλογές του ΕΚΟΜΕ') as string}
        mode='info'
        fullWidth
        maxWidth='xl'
        open={open}
        onAccept={() => undefined}
        handleClose={() => setOpen(false)}
        content={
          <TableGridWithFilters
            pageSize={15}
            paginationMode='server'
            rowsPerPageOptions={[15, 30, 45]}
            responseDataFieldName='data'
            responseTotalCountFieldName='totalResults'
            hideFilters
            sortingMode='server'
            columns={columns}
            fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/collections?collectionInternalFlag=true&is_public=1`}
          />
        }
      />
    </>
  );
};

export default SullogesAll;
